const CSS_CLASSES = {
  ROOT: 'mdc-fab',
  ICON: 'mdc-fab__icon',
  LABEL: 'mdc-fab__label',
  MINI: 'mdc-fab--mini',
  EXTENDED: 'mdc-fab--extended',
  EXITED: 'mdc-fab--exited',
};

export {CSS_CLASSES};
